import { AnyAction } from 'redux';

import {
    CREATE_INTERNAL_NOTES_SUCCESS,
    DELETE_INTERNAL_NOTES_SUCCESS,
    GET_INTERNAL_NOTES_SUCCESS,
    GET_RECEIPT_INTERNAL_NOTES_SUCCESS,
    RESET_RECEIPT_INTERNAL_NOTES,
    UPDATE_INTERNAL_NOTES_SUCCESS,
} from '../actions/internal-notes-actions';
import { InternalNote } from '../models/internal-note';
import { ReceiptNoteType } from '../models/enums/receipt-note-type';

export interface InternalNotesReducerState {
    notes: InternalNote[];
    receiptNotes: InternalNote[];
    receiptNoteType: ReceiptNoteType | null;
}

export const initialInternalNotesReducerState: InternalNotesReducerState = {
    notes: [],
    receiptNotes: [],
    receiptNoteType: null,
};

export const internalNotesReducer = (
    state: InternalNotesReducerState = initialInternalNotesReducerState,
    action: AnyAction
): InternalNotesReducerState => {
    const { type } = action;

    switch (type) {
        case GET_INTERNAL_NOTES_SUCCESS: {
            return {
                ...state,
                notes: action['notes'],
            };
        }

        case GET_RECEIPT_INTERNAL_NOTES_SUCCESS: {
            if (action['receiptNotes'].length === 0 && state.receiptNotes.length === 0) {
                return {
                    ...state,
                };
            }

            if (action['receiptNotes'] === state.receiptNotes) {
                return {
                    ...state,
                };
            }

            return {
                ...state,
                receiptNotes: action['receiptNotes'],
                receiptNoteType: action['receiptNoteType'],
            };
        }

        case RESET_RECEIPT_INTERNAL_NOTES: {
            return {
                ...state,
                receiptNotes: [],
            };
        }

        case CREATE_INTERNAL_NOTES_SUCCESS: {
            return {
                ...state,
                notes: [...state.notes, action['note']],
            };
        }

        case DELETE_INTERNAL_NOTES_SUCCESS: {
            return {
                ...state,
                notes: state.notes.filter(note => note.id !== action['id']),
            };
        }

        case UPDATE_INTERNAL_NOTES_SUCCESS: {
            const notes = [...state.notes];
            const index = state.notes.findIndex(note => note.id === action['note'].id);
            if (index === -1) {
                return state;
            }
            notes[index] = action['note'];

            return {
                ...state,
                notes,
            };
        }

        default: {
            return state;
        }
    }
};
